import React, { Fragment, useEffect, useRef, useState } from 'react';

import { useLocation, useMedia } from 'react-use';
// import { XMarkIcon } from '@heroicons/react/20/solid';
import { Dialog, Transition } from '@headlessui/react';
import {
  fromRole,
  ProfileModel,
  ProjectModel,
  SbCurrentUser,
  SubmissionBoardModel,
} from '../component/SbModel';
import { showToast } from '../../shared/Toast';
import { SbProfileItem } from '../recipient/SbProfileItem';
import ProfileFilter from '../component/ProfileFilter';
import submissionBoardService from '../../services/SubmissionBoardService';
import Button from '../component/Button';
import { RefreshCcwIcon, XIcon } from 'lucide-react';
import userService from '../../services/UserService';
import { useIsMobile } from '../component/useIsMobile';
import UserFilter from '../../directory/UserFilter';

export interface SbProfilesProps {
  currentUser: SbCurrentUser;
  project: ProjectModel;
  submissionBoardModel: SubmissionBoardModel;
  dialogCloseHandler?: (open: boolean) => void;
  profileSelected?: (profileInfo: any) => void;
}
export default function AllProfiles({
  currentUser,
  project,
  submissionBoardModel,
  dialogCloseHandler,
  profileSelected,
}: SbProfilesProps) {
  const location = useLocation();
  const [records, setRecords] = useState<ProfileModel[]>([]);
  const [userGroups, setUserGroups] = useState([]);
  const [favoritesLoaded, setFavoritesLoaded] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const observerRef = useRef(null);
  // const listRef = useRef(null);
  const [noMoreData, setNoMoreData] = useState<string>('');
  const perPage: number = 12; // Number of records to fetch per page

  const [open, setOpen] = useState(true);
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const [filteredParams, setFilteredParams] = useState<any>({});
  const isMobile = useIsMobile();
  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);

  useEffect(() => {
    fetchUserGroups();
    fetchFavorites();
  }, []);
  // Close mobile filter drawer when window is resized to desktop size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024 && isMobileFilterOpen) {
        setIsMobileFilterOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobileFilterOpen]);

  const fetchUserGroups = async () => {
    try {
      const response = await userService.getGroups(1, 999999);
      if (response && response.length > 0) {
        let groups = [...response.map((item) => {
          return {id: item.id, name: item.title};
        })];
        setUserGroups(groups);
      }
    } catch (error) {
      console.error('Error loading favorites:', error);
    } finally {
    }
  };

  const fetchFavorites = async () => {
    try {
      const response = await userService.getFavorites(1, 999999);
      if (response && 'favorites' in response) {
        // let groups = [...response.map((item) => {
        //   return {id: item.id, name: item.title};
        // })];
        console.log('response.favorites', response.favorites)
        setFavorites(response.favorites);
      }
    } catch (error) {
      console.error('Error loading favorites:', error);
    } finally {
      setFavoritesLoaded(true);
      console.log('setFavoritesLoaded');
    }
  };
  useEffect(() => {
    if(favoritesLoaded) {
     loadMore();
    }
  }, [favoritesLoaded]);
  const loadMore = async () => {
    if (!favoritesLoaded) {
      return;
    }
    if (isLoading) {
      console.log('sb: fetchSubmissionBoards isLoading');
      return;
    }
    console.log('sb: isLoading true');
    setIsLoading(true);
  };

  useEffect(() => {
    if (isLoading) {
      console.log('sb::winodws isLoading');
      const load = async () => {
        await fetchFromServer(page);
      };
      load();
    }
  }, [isLoading]);

  // useEffect(() => {
  //   // When submissionBoardModel changes (e.g., profile added to team), refresh the list
  //   setRecords([]);
  //   setPage(1);
  //   setNoMoreData('');
  //   loadMore();
  // }, [submissionBoardModel]);
  // Load first page
  // useEffect(() => {
  //   console.log('sb::winodws location');
  //   setNoMoreData('');
  //   setPage(1);
  //   setRecords([]);
  //   fetchUserGroups();
  // }, [location]);

  // useEffect(() => {
  //   const checkIfMoreNeeded = () => {
  //     const listBottom = listRef.current?.getBoundingClientRect().bottom || 0;
  //     console.log('sb::winodws listBottom', listBottom, window.innerHeight);
  //     if (listBottom < window.innerHeight) {
  //       console.log('sb::winodws loadmore');
  //       loadMore();
  //     }
  //   };
  //   checkIfMoreNeeded();
  //   // window.addEventListener('resize', checkIfMoreNeeded);
  //   // return () => window.removeEventListener('resize', checkIfMoreNeeded);
  // }, [records]);

  useEffect(() => {
    console.log('use effect filterParams loadMore '  , filteredParams)
    setNoMoreData('');
    setPage(1);
    setRecords([]);
    loadMore();
  }, [filteredParams]);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        console.log('sb::intersect:observerRef loadmore');
        loadMore();
      }
    }, {
      // Adjusts the viewport boundary. This makes the intersection trigger 100px 
      // *before* the element reaches the true bottom of the screen.
      rootMargin: '0px 0px 100px 0px',
      threshold: 0 // Default is 0 anyway, but ensures it triggers as soon as 
      // even 1 pixel is visible.
    });

    if (observerRef.current) {
      console.log('observerRef start observerRef')
      observer.observe(observerRef.current);
    } else {
      console.log('no observerRef')
    }

    return () => {
      console.log('observerRef disconnect')
      observer.disconnect()
    };
  }, [observerRef.current, records]);

  const filterProfiles = (filtered: any) => {
    setFilteredParams(filtered);
  };
  const fetchFromServer = async (pageParam: number) => {
    try {
      if (noMoreData.length > 0 && pageParam != 0) {
        return;
      }
      if (records.length <= 0) {
        pageParam = 1;
      }
      pageParam = pageParam <= 0 ? 1 : pageParam;
      let users = await submissionBoardService.getAllPerformers(
        project.uuid,
        submissionBoardModel.id,
        filteredParams,
        pageParam,
        perPage
      );
      if (users && users.length > 0) {
        setPage((prev) => prev + 1);
        users.map((item) => {
          item.is_fav = favorites.findIndex((item2) => item2 == item.uuid) >= 0;
        })
        setRecords((prevRecords) => [...prevRecords, ...users]);
        if (users.length < perPage) {
          // This was the last page - we got fewer profiles than requested
          setNoMoreData('All Profiles Loaded');
        } else {
          setNoMoreData('');
        }
        return;
      }
      if (pageParam > 1) {
        setNoMoreData('All Profiles Loaded');
      } else if (records.length <= 0) {
        setNoMoreData('No matching profiles.');
      } else {
        setNoMoreData('All Profiles Loaded');
      }
    } catch (error) {
      showToast('Error while fetching submission boards.', 'danger');
    } finally {
      console.log('sb: isLoading false');
      setIsLoading(false);
    }
  };
  // on search or filter change, reset page and records
  // const filterData = async () => {
  //   setPage(1);
  //   setRecords([]);
  //   await fetchFromServer(0);
  // };

  const onCloseDialog = (value: boolean) => {
    dialogCloseHandler(value);
  };
  // Escape close popup end
  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => onCloseDialog(false)}>
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-customGray" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 flex items-center justify-center p-5 sm:px-16 sm:py-12 bg-gray-600 bg-opacity-40 mt-14 backdrop-blur-sm">
            {/* <div className="flex max-h-full items-center justify-center p-4 md:p-8 text-center"> */}
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="relative flex w-full h-full max-w-6xl flex-col gap-2-1 pt-5 pb-10 bg-white shadow-xl-0-19-40-8 rounded-md"
              // className="w-full max-w-5xl transform rounded-2xl p-4 bg-white text-left align-middle shadow-xl transition-all"
              >
                <div className="h-full sm:scrollable-content sm:overflow-y-auto justify-items-center">
                  <div className="flex w-full h-full flex-col ">
                    <div className="flex flex-col h-full justify-items-center gap-2-1 ">
                      {/* title close button */}
                      <div className="flex items-center justify-between px-2 sm:px-5 py-3 mb-0 sm:mb-4">
                        <div className="flex flex-row text-base sm:text-lg font-medium">
                          <span className="whitespace-nowrap">Add Profiles to your Submission <br className="sm:hidden" />Board</span>
                        </div>
                        <button
                          id={'allprofiles_close_model_id'}
                          type="button"
                          className="flex h-8 w-8 items-center justify-center rounded-md bg-white flex-shrink-0"
                          onClick={() => onCloseDialog(false)}
                        >
                          <span className="sr-only">Close menu</span>
                          <XIcon className="h-8 w-8" aria-hidden="true" />
                        </button>
                      </div>
                      {/* title close button end */}
                      <div
                        className="flex w-full flex-col sm:flex-row scrollable-content overflow-y-auto sm:px-6 "
                      // className="mt-1 justify-items-center flex flex-col sm:flex-row"
                      // style={{ maxHeight: '80vh' }}
                      >
                        {/* search right panel */}
                        <div className="flex flex-col w-full p-0 px-2 sm:px-2 max-h-full gap-5"
                          style={{
                            maxWidth: (isMobile ? null : ('12.5rem'))
                          }}>
                          <div className="flex lg:pb-10 pr-7 w-full flex-col max-h-full overflow-visible gap-5 border-r-2 sm:border-gray-300">
                             {isMobile ?  (
                            <div className='justify-items-end items-center'><button
                              onClick={() => {
                                setIsMobileFilterOpen(true);
                              }}
                              className="lg:hidden flex items-center gap-2 px-3 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700"
                            >
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                              </svg>
                              Filters
                            </button>
                            </div>
                             ):
                            <div className="w-full text-sm font-medium text-gray-700 px-0 sm:px-0">
                              Search By:
                            </div>
                            }
                            <UserFilter
                                          openFilters={isMobile?isMobileFilterOpen:false}
                                          firstnameLastNameshow={false}
                                          keywordshow={true}
                                          userGroupshow={false}
                                          userGroupsAll={[]}
                                          users={[]}
                                          // measurementRanges={measurementRanges}
                                          measurementRanges={{
                                            height: {
                                              min: 91, // 3ft : 91.44cm
                                              max: 244, // 8ft: 243.84cm
                                            },
                                            weight: {
                                              min: 22, // 50:lbs = 22.6796kg
                                              max: 182, // 400:lbs = 181.437kg
                                            },
                                          }}
                                          currentUser={currentUser}
                                          onFilter={(filteredUsers, filterParams: any) => {
                                            // setFilteredUsers()
                                            console.log('loadmore: filterParams2', filterParams)
                                            // Handle all cases: filterPresent == 0 (reset), 1 (filters active), 2 (clear all)
                                            // setfilteredParams(filterParams)
                                            filterProfiles(filterParams);
                                          }}
                                          showFavoritesOnly={false}
                                          masterSkills={[]}
                                          // favorites={favoritesUsers}
                                          onClose={function (): void {
                                            setIsMobileFilterOpen(false);
                                          }}
                                        />
                            {/* <ProfileFilter
                              firstnameLastNameshow={false}
                              keywordshow={true}
                              userGroupshow={false}
                              userGroupsAll={userGroups}
                              // measure_system ={currentUser.measure_system}
                              onFilter={function (users: any, filterParams: any): void {
                                filterProfiles(filterParams);
                              }}
                              measurementRanges={{
                                height: {
                                  min: 91, // 3ft : 91.44cm
                                  max: 244, // 8ft: 243.84cm
                                },
                                weight: {
                                  min: 22, // 50:lbs = 22.6796kg
                                  max: 182, // 400:lbs = 181.437kg
                                },
                              }}
                              users={[]}
                              currentUser={currentUser}
                            /> */}
                          </div>
                        </div>
                        {/* search right panel end*/}

                        <div className="flex flex-col w-full p-0 max-h-full">
                          {/* <%# profiles start %> */}
                          {
                            records.length <= 0 && (
                              <>
                                {(isLoading || !favoritesLoaded) && (
                                  <>
                                    <div
                                      className={
                                        (is400_639Screen ? 'px-2' : 'p-0') +
                                        ' gap-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4'
                                      }
                                    >
                                      <div className='flex flex-1 flex-col bg-white rounded-xl p-4 w-full' style={{
                                        minWidth: '11.875rem'
                                      }}>&nbsp;</div>
                                      <div className='flex flex-1 flex-col bg-white rounded-xl p-4 w-full' style={{
                                        minWidth: '11.875rem'
                                      }}>&nbsp;</div>
                                      <div className='flex flex-1 flex-col bg-white rounded-xl p-4 w-full' style={{
                                        minWidth: '11.875rem'
                                      }}>&nbsp;</div>
                                      <div className='flex flex-1 flex-col bg-white rounded-xl p-4 w-full' style={{
                                        minWidth: '11.875rem'
                                      }}>&nbsp;</div>
                                    </div>
                                    <div className="flex items-center flex-col py-4">
                                      <div className="font-bold text-xl">Loading...</div>
                                    </div>
                                  </>
                                )}
                                {!isLoading && favoritesLoaded && (
                                  <div className="flex items-center flex-col py-4">
                                    <div className="font-bold text-xl">No Profiles Found</div>
                                  </div>
                                )}
                              </>
                            )}
                          {records.length > 0 &&
                            <div className="flex w-full flex-col max-h-full scrollable-content overflow-y-scroll gap-3 px-2 sm:px-2.5">
                              <div className="w-full text-sm font-medium text-gray-700 mb-2 sm:mb-0">
                                Available Performers
                                {/* ({records.length}): */}
                              </div>
                              <div
                                className={
                                  (is400_639Screen ? 'px-0' : 'p-0') +
                                  ' gap-3 flex flex-col w-full flex-col sm:grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4'
                                }
                              >

                                {records.map((user, index) => {
                                  return (
                                    <SbProfileItem
                                      key={index}
                                      currentUser={currentUser}
                                      indexRow={index}
                                      submissionBoardModel={submissionBoardModel}
                                      project={project}
                                      user={user}
                                      from={fromRole.SB_CREATOR}
                                      profileIndex={0}
                                      profileSelected={async (profileInfo: any) => {
                                        // Update the local state to reflect the change
                                        setRecords((prevRecords) => {
                                          return prevRecords.map((record) => {
                                            if (record.id === profileInfo.profile_id) {
                                              if (profileInfo.action === 'removed') {
                                                // Update the profile to show it's not in the board
                                                return {
                                                  ...record,
                                                  is_in_board: false,
                                                  sb_profiles: [],
                                                };
                                              } else {
                                                // Update the profile to show it's in the board
                                                return {
                                                  ...record,
                                                  is_in_board: true,
                                                  sb_profiles: [
                                                    {
                                                      id: Date.now(), // temporary id
                                                      submission_board_id:
                                                        profileInfo.submission_board_id,
                                                      profile_status: 0, // pending status
                                                    },
                                                  ],
                                                };
                                              }
                                            }
                                            return record;
                                          });
                                        });

                                        if (profileSelected) {
                                          await profileSelected(profileInfo);
                                        }
                                      }}
                                    />
                                  );
                                })}
                              </div>
                              <div id='load_more_id' className="flex items-center flex-col py-4 pb-20 sm:pb-4" ref={observerRef} style={{
                                paddingBottom: isMobile ? '6rem' : '1rem'
                              }}>
                                {noMoreData.length > 0 && records.length > 0 && (
                                  <div className="font-bold text-xl">All Profiles Loaded</div>
                                )}
                                {noMoreData.length <= 0 && !isLoading && records.length > 0 && (
                                  <Button
                                    id="profiles_search_loadmore_btn"
                                    variant="secondary"
                                    btn_size="small"
                                    className="cursor-pointer"
                                    onClick={() => {
                                      loadMore();
                                    }}
                                  >
                                    <div className="w-6 h-6  flex items-center justify-center">
                                      <RefreshCcwIcon className="h-6 w-6" aria-hidden="true" />
                                    </div>
                                    Load More
                                  </Button>
                                )}
                              </div>
                            </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
            {/* </div> */}
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
